import { useEffect, useState } from 'react';
import { useApolloClient } from '@apollo/client';
import { Button, Modal, Spinner, Table, Alert } from 'reactstrap';
import { GET_SEND_DETAILS_EMAIL_LOG_BY_INVOICE_ID } from '../../queries/vip-workflow';
import CloseModalButton from '../Buttons/CloseModalButton';
import moment from 'moment';

const SendDetailsEmailLogsCardModal = ({
  isModalOpened,
  setIsModalOpened,
  currentInvoiceId,
}: any) => {
  const client = useApolloClient();
  const [loading, setLoading] = useState(false);
  const [logsData, setLogsData] = useState<any[]>([]);
  const [error, setError] = useState<string | null>(null);

  const fetchEmailLogs = async () => {
    setLoading(true);
    setError(null);
    try {
      const { data } = await client.query({
        query: GET_SEND_DETAILS_EMAIL_LOG_BY_INVOICE_ID,
        variables: { invoiceId: currentInvoiceId },
        fetchPolicy: 'network-only',
      });
      setLogsData(data?.packageOrderDetailEmailLogByInvoiceId || []);
    } catch (err: any) {
      console.error('Error fetching email logs:', err);
      setError('Failed to fetch logs');
      setLogsData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isModalOpened && currentInvoiceId) {
      fetchEmailLogs();
    }
  }, [isModalOpened, currentInvoiceId]);

  return (
    <Modal
      isOpen={isModalOpened}
      toggle={() => {
        setIsModalOpened(false);
      }}
      className="modal-dialog-centered modal-secondary"
      size="xl"
      fade={false}
    >
      <div className="modal-body pb-3">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <h1 className="m-0">Delivery Detail Email Logs</h1>
          </div>
          <div>
            <CloseModalButton
              handleCloseModalButtonClick={(e) => {
                e.preventDefault();
                setIsModalOpened(false);
              }}
            />
          </div>
        </div>

        {error && <Alert color="danger">{error}</Alert>}

        {loading ? (
          <div className="d-flex justify-content-center py-5">
            <Spinner animation="border" variant="info" size="lg" />
          </div>
        ) : logsData && logsData.length > 0 ? (
          <div className="table-responsive">
            <Table striped hover>
              <thead className="table-light">
                <tr>
                  {/* <th>ID</th> */}
                  <th>Invoice ID</th>
                  <th>User</th>
                  <th>Created At</th>
                </tr>
              </thead>
              <tbody>
                {logsData.map((log: any, index: number) => (
                  <tr key={log.id || index}>
                    {/* <td>{log.id}</td> */}
                    <td>{log.invoiceId}</td>
                    <td>{log.user || '-'}</td>
                    <td>
                      {log.createdAt ? moment(log.createdAt).format('MMM DD, YYYY h:mm A') : '-'}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        ) : (
          <Alert color="info" className="text-center">
            <i className="fa fa-info-circle"></i>&nbsp; No logs exist for this invoice
          </Alert>
        )}

        <div className="text-right mt-3">
          <Button color="secondary" onClick={() => setIsModalOpened(false)}>
            Close
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default SendDetailsEmailLogsCardModal;
